const mapperToOption = (
    option,
    id = 'id',
    title = 'title',
    icon = 'icon',
    color = 'color',
    status = 'status',
    description = 'description'
) => {
    if (!option[id] || !option[title]) {
        return null
    }

    return {
        value: option[id],
        label: option[title],
        icon: option[icon] || '',
        color: option[color] || { hex: '', title: '' },
        status: option[status] || '',
        description: option[description] || '',
    }
}

export { mapperToOption }
